import Layout from '../layout'

const CaliforniaLanding = () => {
  return (
    <>
      <Layout cityName="San Francisco" marketName="NorCal" marketCode="CA" />
    </>
  )
}

export default CaliforniaLanding
